export const API_KEY = "AIzaSyAFjOM6FuYQElINKCSITwvWmj0Mw5oA0ik";

export default API_KEY;